module.exports = __webpack_public_path__ + "static/media/collage.7880eb36.jpg";